import React, { createContext, ReactNode, useContext } from 'react';

import { SemboMarket } from '../utils/markets';

const MarketContext = createContext<SemboMarket | undefined>(undefined);

export const useMarket = (): SemboMarket =>
  useContext(MarketContext) as SemboMarket;

type MarketProviderProps = {
  market: SemboMarket | null;
  children: ReactNode;
};

export const MarketProvider: React.FC<MarketProviderProps> = ({
  market,
  children,
}) => {
  return (
    <MarketContext.Provider value={market as SemboMarket}>
      {children}
    </MarketContext.Provider>
  );
};
